var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownStrokeStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.50003L3 3.50005C2.44771 3.50005 2 3.94776 2 4.50005V12.5C2 13.0523 2.44772 13.5 3 13.5H7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9477 3.50003H7V13.5L13.9158 20.5L13.9867 20.4282C15.432 18.9653 15.8379 16.7526 15.0078 14.862L14.4098 13.5H20.0224C21.3836 13.5 22.3371 12.1397 21.8874 10.8393L19.8127 4.83933C19.5353 4.03716 18.7874 3.50003 17.9477 3.50003Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownStrokeStandard);
export default __webpack_public_path__ + "static/media/thumbs-down-stroke-standard.b432d40c53900d6ef03f23c6b645cf32.svg";
export { ForwardRef as ReactComponent };